import axios, { AxiosResponse } from 'axios'
import { getTokenConfig } from '../../../../../src/auth'
import {
  CustomerItem,
  CommissionCfgRow,
  CommissionConfigsApiResponse,
  CommissionConfigApiRow
} from '../core/CommissionConfigs.model'

const BASE = `${process.env.REACT_APP_API_URL}`

/**
 * 1) Listado de clientes para el <Select>
 */
export async function fetchCustomers(): Promise<CustomerItem[]> {
  const cfg = await getTokenConfig()
  const res: AxiosResponse<{ data: { customers: CustomerItem[] } }> =
    await axios.get(`${BASE}/admin/customers-payment-platform`, cfg)
  return res.data.data.customers
}

/**
 * 2) Trae y aplana el listado de comisiones (configuraciones),
 *    devolviendo también la lista de techPartners para las columnas.
 *    (Usa comissionBase* + isPercentage* del backend nuevo)
 */
export async function fetchCommissionConfigs(
  page: number,
  limit: number,
  customerId?: number
): Promise<{
  rows: CommissionCfgRow[]
  totalPages: number
  techPartners: string[]
}> {
  const cfg = await getTokenConfig()
  const params: Record<string, any> = { page, pageSize: limit }
  if (customerId != null) {
    params.search = customerId.toString()
  }

  const res: AxiosResponse<{ data: CommissionConfigsApiResponse }> =
    await axios.get(`${BASE}/admin/client-commission-configs`, { ...cfg, params })

  const api = res.data.data

  // Aplanamos cada row de la API con los CAMPOS NUEVOS
  const flatRows: CommissionCfgRow[] = api.rows.flatMap((r: CommissionConfigApiRow) =>
    r.commissions.map(c => ({
      customerId:              r.customerId,
      customerName:            r.customerName,
      techPartner:             c.techPartner,

      comissionBaseTech:       Number(c.comissionBaseTech ?? 0),
      isPercentageTech:        !!c.isPercentageTech,

      comissionBaseCommercial: Number(c.comissionBaseCommercial ?? 0),
      isPercentageCommercial:  !!c.isPercentageCommercial,

      status:                  c.status,
    }))
  )

  const totalPages = Math.ceil((api.total ?? 0) / limit)

  return {
    rows: flatRows,
    totalPages,
    techPartners: api.techPartners || []
  }
}

/**
 * 3) Descarga el CSV directamente (sin pasar por S3)
 */
export async function downloadCommissionConfigsCsv(
  page: number,
  limit: number,
  customerId?: number
): Promise<Blob> {
  const cfg = await getTokenConfig()
  const params: Record<string, any> = { page, pageSize: limit, mode: 'download' }
  if (customerId != null) {
    params.search = customerId.toString()
  }

  const response = await axios.get(
    `${BASE}/admin/client-commission-configs`,
    { ...cfg, params, responseType: 'blob' }
  )
  return response.data
}
